import { MultipleType } from '@app/shared/models/contracts/enums/shared-enums';
import { enumToOptions } from '@app/shared/helpers';

export const DEAL_THESIS_EXIT_MULTIPLE_OPTIONS = enumToOptions(MultipleType, undefined, false);
